module.exports = __webpack_public_path__ + "static/assets/b433ee02a13fa2a12f7f7059f1f6729a.svg";